export enum ShopItemType {
    MATERIAL_GOODS = 'MATERIAL_GOODS',
    TREES = 'TREE',
    TREES_DIGITAL_GOODS = 'TREES_DIGITAL_GOODS',
    SUBSCRIPTION_SHOP = 'SUBSCRIPTION_SHOP',
    GIFT_CARD = 'GIFT_CARD',
  }
